export enum AlertNoticeComparisonEnum {
    BIGGER_OR_EQUAL = 'BIGGER_OR_EQUAL',
    SMALLER_OR_EQUAL = 'SMALLER_OR_EQUAL'
}